<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Time Off Journals</p>
      </div>
      <div class="border-b-0.5 flex justify-between items-center p-2">
        <!-- search -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          :page-sizes="pageSizes"
          :page-index="pageIndex"
          :page-size="pageSize"
          layout="sizes"
          :total="currentTableData.length"
        >
        </el-pagination>
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="bg-gray-200 w-52 py-1 rounded-md"
        />
        <!-- search -->
        <div class="flex flex-wrap justify-end w-full gap-3">
          <div
            @click="showCreateJournal = true"
            class="bg-primary flex text-white items-center text-sm px-2 py-1 rounded-md cursor-pointer"
          >
            <img class="h-5" src="@/assets/icons/plus-small.svg" />
            <p>Create</p>
          </div>
        </div>
      </div>
      <div class="px-2 pb-2">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocCrSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_loca }}
          </div>
        </transition>
        <div>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
          />

          <ve-table
            :columns="columns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No Leave Types found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
      </div>
    </div>
    <!-- create -->
    <CreateTimeoffJournal
      @close="handleClose"
      :showCreateTimeoffJournal="showCreateTimeoffJournal"
      @closeOnSuccess="handleCloseOnSuccess"
      :reload="reload"
      :title="modalTitle"
    ></CreateTimeoffJournal>
    <CreateJournal
      @close="showCreateJournal = false"
      :showCreateJournal="showCreateJournal"
      @closeOnSuccess="handleCloseOnSuccess"
      :reload="reload"
    ></CreateJournal>

    <!-- edit -->
    <EditJournal
      @close="handleClose"
      :journalToEdit="journalToEdit"
      :info="info"
      :showEditJournal="showEditJournal"
      @closeOnSuccess="handleCloseOnSuccess"
    >
    </EditJournal>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
import axios from "axios";
import CreateTimeoffJournal from "@/components/CompanySetups/timeOffSetups/create.vue";
import CreateJournal from "@/components/CompanySetups/timeOffSetups/createJournal.vue";
import EditJournal from "@/components/CompanySetups/timeOffSetups/editJournal.vue";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import { mapGetters } from "vuex";
import { utils, writeFileXLSX } from "xlsx";

// import Switches from 'vue-switches';
export default {
  name: "timeOffJournalsList",
  components: {
    Loader,
    CreateTimeoffJournal,
    EditJournal,
    ActionWarning,
    CreateJournal,
  },

  data() {
    return {
      showCreateTimeoffJournal: false,
      showCreateJournal: false,
      showEditJournal: false,
      loading: false,
      get_error: null,
      create_success: "Leave Type created successfully",
      modalTitle:'Create Time off Journal Title',
      del_loca: null,
      del_error: null,
      info: null,
      message: null,
      title: null,
      searchInput: "",
      showLocCrSuccess: false,
      showLocDelSuccess: false,
      showActions: false,
      journalToDelete: null,
      showWarning: false,
      journalToEdit: {},
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Code",
          key: "journalCode",
          title: "Journal Code",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <div
              on-click={() => this.viewJournal(row)}
              class="flex gap-5 items-center"
            >
              <p class="text-blue-500 cursor-pointer">{row.Code}</p>
            </div>
          ),
        },
        {
          field: "Name",
          key: "journalName",
          title: "Journal Name",
          headerAlign: "left",
          align: "left",
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getJournals();
    this.setPageSizes();
  },
  methods: {
    viewJournal(journalId) {
      this.$store.commit("setCurrentJournalId", journalId);
      this.$router.push({
        name: "journals",
        params: { type: "journal-id", company: this.getOrganization },
      });
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleClose() {
      this.showCreateTimeoffJournal = false;
      this.showEditJournal = false;
    },
    handleCloseOnSuccess() {
      this.showCreateTimeoffJournal = false;
      this.showLocCrSuccess = false;
      this.showEditJournal = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getJournals();
    },

    reload() {
      this.getJournals();
    },
    setIsConfirmed() {
      this.showWarning = false;
      this.deletejournal(this.journalToDelete);
    },

    handleEditButtonClick(journal) {
      // Handle the button click for the edit button
      //console.log(journal);
      this.journalToEdit = {
        journalId: journal.Id,
        Name: journal.Code,
        Country: journal.Name,
        ...journal,
      };
      this.showEditJournal = true;
    },
    handleDeleteButtonClick(journal) {
      // Handle the button click for the delete button
      //console.log(journal);
      this.title = `Delete ${journal.Name}`;
      this.message = `You are about to delete ${journal.Name}!`;
      this.journalToDelete = journal;
      this.showWarning = true;
    },

    handleDeleteOnSuccess() {
      this.showLocDelSuccess = false;

      this.getJournals();
    },
    // /{organization}/timeoff/journal/v1/request
    getJournals() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/timeoff/journal/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.tableData = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // /{organization}/timeoff/journal/v1/delete
    deletejournal(row) {
      //console.log(row)
      this.loading = true;

      const data = {
        TimeoffJournalId: row.TimeoffJournalId,
      };
      axios
        .delete(`${this.getOrganization}/timeoff/journal/v1/delete`, {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },

          data,
        })
        .then(
          (response) => {
            this.loading = false;

            if (response.data.StatusCode == 200) {
              this.handleDeleteOnSuccess();
              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });
            } else {
              this.del_error = response.data.StatusMessage;
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
            this.$notify.error({ title: "Failure", message: this.del_error });
          }
        );
    },

    editjournal(row) {
      this.showEditJournal = true;
      this.info = row;
    },

    exportTemplate() {
      const ws = utils.json_to_sheet(this.tableData);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Data");

      writeFileXLSX(wb, "journals.xlsx");
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}
</style>
